import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Divider,
  Select,
  Box,
  FormControl,
  InputLabel,
} from "@mui/material";

export default function DownloadMenuButton({
  onPdf,
  onZip,
  selectedMonth,
  setSelectedMonth,
  availableMonths,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button variant="outlined" onClick={handleOpen}>
        ⬇️ Download ▾
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            onPdf();
            handleClose();
          }}
        >
          📄 Download Summary PDF
        </MenuItem>
        <MenuItem
          onClick={() => {
            onZip();
            handleClose();
          }}
        >
          📦 Download All Receipts (ZIP)
        </MenuItem>
        <Divider />
        <Box px={2} py={1}>
          <FormControl fullWidth size="small">
            <InputLabel id="month-select-label">Month</InputLabel>
            <Select
              labelId="month-select-label"
              value={selectedMonth}
              label="Month"
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                handleClose();
              }}
              displayEmpty
            >
              <MenuItem value="">📅 All Months</MenuItem> {/* ✅ Add this */}
              {availableMonths.map((month) => (
                <MenuItem key={month} value={month}>
                  {new Date(`${month}-01`).toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                  })}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Menu>
    </>
  );
}
